<template>
  <div class="pt-3 pb-2 page-container torah-resources-page">
    <div class="title d-flex align-items-center">
      <h3 class="text-uppercase"></h3>
    </div>
    <ul class="daf-resources list-unstyled" v-if="resources">
      <li
        v-for="resource in resources"
        :key="resource.id"
        class="mb-4 rounded border"
      >
        <a
          :href="resource.url_key"
          target="_blank"
          class="d-flex flex-wrap no-gutters border border-primary no-decoration text-white align-items-center bg-dark-blue"
        >
          <div
            class="col-md-4 col-12 text-center resources-container align-self-stretch"
          >
            <b-img
              :src="resource.image.url"
              width="500px"
              height="200px"
              v-if="resource.image"
              fluid
            />
          </div>
          <div class="col-12 col-md-8 p-2 py-md-4 text-center text-md-left">
            <h2 class="pl-md-4 pr-md-3">{{ resource.name }}</h2>
            <div class="pl-md-4 pr-md-3" v-html="resource.content"></div>
          </div>
        </a>
      </li>
    </ul>
  </div>
</template>
<script>
export default {
  metaInfo() {
    return { title: this.$_t("pages:resources.meta") };
  },
  i18nOptions: {
    namespaces: "pages",
    keyPrefix: "resources",
  },
  data: function () {
    return {
      resources: null,
    };
  },
  created: function () {
    this.getData();
  },
  methods: {
    getData: function () {
      this.$http
        .get("api/resources")
        .then((response) => (this.resources = response.data));
    },
  },
};
</script>
<style lang="scss" scoped>
.torah-resources-page {
  a:hover {
    text-decoration: none;
  }
  .resources-container {
    img {
      height: 100%;
      width: 100%;
    }
  }
}
</style>
